<div #itemDivs *ngFor="let item of items; index as index" class="item">
    <div class="p-inputgroup citation-row">
        <span class="citation" (click)="editItem(index)">{{item.format()}}</span>
        <button type="button" pButton class="button" icon="fas fa-trash" (click)="removeItem(index)"></button>
    </div>
</div>
<p-button class="add-button" icon="fas fa-plus" label="Neue Quelle" (click)="addItem()"></p-button>
